import { render, staticRenderFns } from "./ClinicPrice.vue?vue&type=template&id=f28899d4&scoped=true"
import script from "./ClinicPrice.vue?vue&type=script&lang=js"
export * from "./ClinicPrice.vue?vue&type=script&lang=js"
import style0 from "./ClinicPrice.vue?vue&type=style&index=0&id=f28899d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28899d4",
  null
  
)

export default component.exports